import React from "react";
import ContentBox from "../../Box/ContentBox/ContentBox";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Typography from "@mui/material/Typography";
import ProductBox from "@/src/components/ProductBox/ProductBox";

export const StatusBoxDeactivatedProduct = () => {
  return (
    <ProductBox headline={"Produkt nicht mehr unterstützt"}>
      <Typography>
        Dieses Produkt wird von uns nicht mehr angeboten. Bisher erhaltene Dokumente können sie im Bereich “Meine Dokumente” weiterhin abrufen.
      </Typography>
    </ProductBox>
  );
};
